import { defineComponent, reactive, toRefs, watch } from "vue";
import { Line } from "vue-chartjs";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

import { LineProps } from "./interfaces/line-props.interface";
import { LineDataset } from "./interfaces/line-dataset.interface";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

export default defineComponent({
    name: 'LineComponent',
    props: {
        labels: { type: Array as () => string[], required: true },
        datasets: { type: Array as () => LineDataset[], required: true },
        colors: { type: Array as () => string[]}
    },
    components: {
        Line
    },
    setup(props: LineProps, { emit }) {
        const config = reactive({
            loaded: false,
            key: 0
        });

        const lineDataConfig = reactive({
            lineData: {
                labels: [] as string[],
                datasets: [] as LineDataset[],
            }
        });

        const lineOpts = {
            responsive: true,
            elements: {
                point: {
                    radius: 4
                }
            }
        }

        watch([() => props.labels, () => props.datasets], (
            [newLabels, newData], [oldLabels, oldData]
        ) => {
            if (newLabels != oldLabels) {
                lineDataConfig.lineData.labels = newLabels;
                lineDataConfig.lineData.datasets = newData;
                config.key++;
                config.loaded = true;
            }
        });

        return {
            ...toRefs(config),
            ...toRefs(lineDataConfig),
            lineOpts
        }
    }
});